import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { GNoValidation } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { DOWNLOADREGISTRATIONVALIDATION, REGVALIDATIONREPORT } from '../../../config/ApiConstant';
import { RegistrationValidationReportListColumns } from '../../../appconfig/DatatableSetting';
import { combinedFullNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { InputText } from 'primereact/inputtext';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const RegistrationValidation = () => {
    document.title = 'Registration Validation | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [registrationVlidationList, setRegistrationVlidationList] = useState<any>([]);
    const [regDetails, setRegDetails] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [totalReg, setTotalReg] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const handleChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setRegDetails({ ...regDetails, [name]: val });
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <div className="input-effect-div">
                        <InputText value={regDetails?.year} name="year" autoComplete="off" placeholder="Enter Year" onChange={(e) => handleChange(e, 'year')} className={errors['year'] && 'p-invalid'} />
                        <span className="focus-bg"></span>
                    </div>

                    <small className="p-invalid-txt">{errors['year']}</small>
                </div>

                <div>
                    <div className="input-effect-div">
                        <InputText value={totalReg} name="total" autoComplete="off" placeholder="Total" disabled className="ml-3" />
                        <span className="focus-bg"></span>
                    </div>
                </div>

                <Button label="Show" onClick={() => getRegistrationVlidation()} loading={showLoading} className="ml-3"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);

            // Request Data
            const requestData = {
                year: regDetails?.year
            };

            const response = await downloadData(DOWNLOADREGISTRATIONVALIDATION, 'Registration_Validation_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Registration_Validation_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getRegistrationVlidationList
    const getRegistrationVlidation = async () => {
        try {
            const { errors, isError } = GNoValidation(regDetails?.year);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);

                // Request Data
                const requestData = {
                    year: regDetails?.year
                };

                const response = await postAllData(REGVALIDATIONREPORT, requestData);

                if (response) {
                    setTotalReg(response.length);
                    setPageLoad(true);
                    setShowLoading(false);
                    setRegistrationVlidationList(response);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Registration Validation'} pageTitle={'Registration Validation'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={registrationVlidationList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {RegistrationValidationReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'EntDt' || col.field === 'LastVDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'app_name') {
                                            return <Column key={col.field} header={col.header} body={combinedFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RegistrationValidationReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
